import process_vars from '../intermediate/process_vars';

// Helpers for element-to-element alignment snapping ("smart guides").
//
// Coordinates are in the react-rnd position space (fraction * vw px) when used
// for the committed snap, and in viewport px when used for live guides — the
// matcher itself is unit-agnostic.

const EDGE_THRESHOLD = 6;    // px: how close an edge must be to snap
const CENTER_THRESHOLD = 11; // px: centers snap from farther away
const CENTER_BIAS = 5;       // px: centers win over a nearby edge

// Collect candidate alignment lines from every element on `page` except those
// in `excludeSet`. Each line is { v: coordinate, c: isCenterLine }.
export function collectCandidates(comps, excludeSet, page, vw, vars) {
    const xs = [];
    const ys = [];
    const xseen = new Set();
    const yseen = new Set();
    const addX = (v, c) => { const key = Math.round(v) + (c ? 'c' : 'e'); if (!xseen.has(key)) { xseen.add(key); xs.push({ v, c }); } };
    const addY = (v, c) => { const key = Math.round(v) + (c ? 'c' : 'e'); if (!yseen.has(key)) { yseen.add(key); ys.push({ v, c }); } };
    for (let k = 0; k < comps.length; k++) {
        if (comps[k].page !== page) continue;
        if (excludeSet.has(k)) continue;
        const x = process_vars(comps[k].position[0], vars) * vw;
        const y = process_vars(comps[k].position[1], vars) * vw;
        const w = process_vars(comps[k].size[0], vars) * vw;
        const h = process_vars(comps[k].size[1], vars) * vw;
        addX(x, false); addX(x + w / 2, true); addX(x + w, false);
        addY(y, false); addY(y + h / 2, true); addY(y + h, false);
    }
    return { xs, ys };
}

// probes / candidates are [{ v, c }]. Returns the best match { line, probeV }
// or null. Center-to-center matches get a wider threshold and a bias so they
// are easier to hit and win over a slightly-closer edge.
export function matchAxis(probes, candidates) {
    let best = null;
    for (let i = 0; i < candidates.length; i++) {
        const cand = candidates[i];
        for (let p = 0; p < probes.length; p++) {
            const probe = probes[p];
            const dist = Math.abs(cand.v - probe.v);
            const centerMatch = cand.c && probe.c;
            const thr = centerMatch ? CENTER_THRESHOLD : EDGE_THRESHOLD;
            if (dist <= thr) {
                const eff = dist - (centerMatch ? CENTER_BIAS : 0);
                if (best === null || eff < best.eff) {
                    best = { line: cand.v, probeV: probe.v, eff };
                }
            }
        }
    }
    return best;
}
